import type { CasinoBonusProgress } from '@mwl/core-lib';

export const getBonusPercent = (casinoBonusProgress: CasinoBonusProgress | null) => {
  if (!casinoBonusProgress) {
    return '0%';
  }

  return `${((100 * casinoBonusProgress.rollingBalance) / casinoBonusProgress.requiredRollingBalance).toFixed(1)}%`;
};
